export default function PrivacidadePage() {
  return (
    <div className="container mx-auto px-4 py-12 max-w-3xl">
      <h1 className="text-3xl font-heading font-bold mb-2">Política de Privacidade</h1>
      <p className="text-sm text-muted-foreground mb-8">Última atualização: setembro de 2026</p>

      <div className="prose prose-sm max-w-none space-y-8 text-foreground">

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">1. Introdução</h2>
          <p className="text-muted-foreground leading-relaxed">
            Esta Política de Privacidade descreve como o AgroAluga coleta, utiliza, armazena e protege seus dados
            pessoais, em conformidade com a Lei Geral de Proteção de Dados (LGPD — Lei 13.709/2018). Ao utilizar a
            plataforma, você concorda com as práticas aqui descritas.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">2. Dados que Coletamos</h2>
          <p className="text-muted-foreground leading-relaxed">Coletamos os seguintes dados:</p>
          <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
            <li><strong>Cadastrais:</strong> nome, e-mail, telefone, cidade e estado</li>
            <li><strong>Perfil:</strong> foto de perfil (opcional)</li>
            <li><strong>Anúncios:</strong> títulos, descrições, preços, fotos e localização dos equipamentos e serviços que você publica</li>
            <li><strong>Localização:</strong> localização aproximada por GPS, apenas quando você autoriza, para exibir anúncios próximos</li>
            <li><strong>Técnicos e de segurança:</strong> token de notificação (para envio de avisos), dados de acesso e uso da plataforma, e sinais técnicos do navegador e endereço IP processados por nosso serviço de proteção contra robôs (anti-bot) ao enviar formulários</li>
            <li><strong>Pagamento:</strong> dados necessários para processar assinaturas são coletados e tratados diretamente pela Stripe; não armazenamos números completos de cartão</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">3. Como Usamos seus Dados</h2>
          <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
            <li>Operar a plataforma e conectar anunciantes e contratantes</li>
            <li>Exibir anúncios relevantes à sua região</li>
            <li>Processar assinaturas e pagamentos dos planos</li>
            <li>Enviar notificações e comunicações sobre a conta, anúncios e mensagens</li>
            <li>Prevenir fraudes, abusos e violações destes termos</li>
            <li>Cumprir obrigações legais</li>
          </ul>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">4. Base Legal</h2>
          <p className="text-muted-foreground leading-relaxed">
            O tratamento de dados fundamenta-se na execução do contrato (uso da plataforma), no consentimento
            (por exemplo, localização por GPS), no legítimo interesse (segurança e melhoria do serviço) e no
            cumprimento de obrigações legais.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">5. Compartilhamento com Terceiros</h2>
          <p className="text-muted-foreground leading-relaxed">
            Não vendemos seus dados. Compartilhamos informações apenas com prestadores de serviço (operadores)
            necessários ao funcionamento da plataforma:
          </p>
          <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
            <li><strong>Supabase</strong> — armazenamento do banco de dados e autenticação</li>
            <li><strong>Vercel</strong> — hospedagem do site</li>
            <li><strong>Stripe</strong> — processamento de pagamentos e assinaturas</li>
            <li><strong>Firebase (Google)</strong> — envio de notificações push</li>
            <li><strong>Resend</strong> — envio de e-mails transacionais</li>
            <li><strong>Cloudflare</strong> — proteção contra robôs e spam (serviço Turnstile) nos formulários. Para distinguir usuários humanos de acessos automatizados, processa o endereço IP e sinais técnicos do navegador no momento do envio. Não é usado para rastrear você entre sites nem para publicidade</li>
            <li><strong>PostHog</strong> — métricas de uso agregadas e anônimas (páginas visitadas, cliques e fluxo de navegação), para melhorar a plataforma. Configurado sem cookies e sem identificar você individualmente</li>
          </ul>
          <p className="text-muted-foreground leading-relaxed mt-3">
            Esses prestadores tratam os dados apenas conforme nossas instruções e suas próprias políticas de
            privacidade. Dados também podem ser divulgados para cumprir ordens legais ou judiciais.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">6. Transferência Internacional de Dados</h2>
          <p className="mb-4">
            Alguns de nossos prestadores de serviço (como Supabase, Vercel, Stripe, Cloudflare e Firebase) podem
            armazenar ou processar dados em servidores localizados fora do Brasil. Nesses casos, adotamos as
            salvaguardas previstas na LGPD para garantir nível de proteção adequado, e o tratamento permanece
            sujeito a esta Política e à legislação brasileira aplicável.
          </p>
          <h2 className="text-xl font-heading font-semibold mb-3">7. Armazenamento e Segurança</h2>
          <p className="text-muted-foreground leading-relaxed">
            Adotamos medidas técnicas e organizacionais para proteger seus dados, incluindo controle de acesso e
            criptografia em trânsito. Após a solicitação de exclusão da conta, os dados pessoais são eliminados em até 30 (trinta) dias, ressalvadas as informações que devemos reter por obrigação legal ou regulatória, mantidas pelo prazo exigido por lei. Os dados são mantidos enquanto sua conta estiver ativa e pelo período necessário
            ao cumprimento de obrigações legais.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">8. Seus Direitos</h2>
          <p className="text-muted-foreground leading-relaxed">Conforme a LGPD, você pode a qualquer momento:</p>
          <ul className="list-disc list-inside text-muted-foreground space-y-1 mt-2">
            <li>Confirmar a existência de tratamento e acessar seus dados</li>
            <li>Corrigir dados incompletos, inexatos ou desatualizados</li>
            <li>Solicitar a exclusão dos seus dados e da sua conta</li>
            <li>Revogar consentimentos concedidos</li>
            <li>Solicitar a portabilidade dos dados</li>
          </ul>
          <p className="text-muted-foreground leading-relaxed mt-3">
            Para exercer esses direitos, entre em contato pelo e-mail abaixo.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">9. Cookies e Armazenamento Local</h2>
          <p className="text-muted-foreground leading-relaxed">
            Utilizamos armazenamento local do navegador para manter sua sessão, preferências e melhorar a experiência
            de uso. Você pode limpar esses dados nas configurações do seu navegador.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-heading font-semibold mb-3">10. Contato do Encarregado</h2>
          <p className="text-muted-foreground leading-relaxed">
            Para dúvidas sobre esta política ou sobre o tratamento dos seus dados, entre em contato pelo e-mail:
            <a href="mailto:agroaluga@outlook.com" className="text-primary hover:underline ml-1">agroaluga@outlook.com</a>
          </p>
        </section>

      </div>
    </div>
  );
}
